import { useState, useEffect, useCallback, useMemo } from 'react';

import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { Button } from 'UIPackage/MainModule/components/Button';
import { SelectTable } from 'CorePackage/FiltersModalModule/components/SelectTable';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import styles from './KnmListTableColumnsModal.module.scss';
import { IKnmRaw } from '../interfaces/IKnmRaw';

interface IKnmListTableColumnsModalProps {
  visible?: boolean;
  tableItems: ITableColumn<IKnmRaw>[];
  onApply: (columns: ITableColumn<IKnmRaw>[]) => void;
  onClose: () => void;
}

export const KnmListTableColumnsModal = ({ visible, tableItems, onApply, onClose }: IKnmListTableColumnsModalProps) => {
  const [currentTableItems, setCurrentTableItems] = useState([...tableItems]);

  const initialCurrentTableItems = useMemo(() => [...tableItems], [tableItems]);

  useEffect(() => {
    setCurrentTableItems([...tableItems]);
  }, [tableItems]);

  const handleApplyButtonClick = useCallback(() => {
    onApply(currentTableItems);
    onClose();
  }, [currentTableItems, onApply, onClose]);

  const handleCancelButtonClick = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleAfterClose = useCallback(() => {
    setCurrentTableItems(initialCurrentTableItems);
  }, [initialCurrentTableItems]);

  return (
    <Modal visible={visible} modalBodyClassName={styles.Body} onClose={handleClose} afterClose={handleAfterClose}>
      <div className={styles.Content}>
        <SelectTable theme="tableColumns" items={currentTableItems} onItemSet={setCurrentTableItems} />
        <div className={styles.FooterButtons}>
          <Button className={styles.ApplyButton} text="Применить" color="primary" onClick={handleApplyButtonClick} />
          <Button
            className={styles.CancelButton}
            text="Отменить"
            color="primary"
            variant="link"
            onClick={handleCancelButtonClick}
          />
        </div>
      </div>
    </Modal>
  );
};
